import tx from "../tx";

const items = [
    {id:10 , nameTx:'Cash'   , name:'Cash'    },
    {id:20 , nameTx:'Card'   , name:'Card'   },
    {id:30 , nameTx:'Web'    , name:'Web'    },
    {id:40 , nameTx:'Teller' , name:'Teller' },
    {id:50 , nameTx:'Bank'   , name:'Bank'   },
];

const values = Object.freeze ({
    CASH  : 10,
    CARD  : 20,
    WEB   : 30,
    TELLER   : 40,
    BANK : 50,

});


function getName(paymentMethodId) {
    switch (paymentMethodId) {
        case values.CASH     : return  items[0].name;
        case values.CARD     : return  items[1].name;
        case values.WEB      : return  items[2].name;
        case values.TELLER   : return  items[3].name;
        case values.BANK     : return  items[4].name;

        default: return paymentMethodId;
    }
}

function translateNames() {
    for (let item of items) {
        item.name = tx.t(item.nameTx);
    }
}

function getItems() { return items }


export default {
    getItems, getName, translateNames, values
}



